module.exports = __webpack_public_path__ + "img/产品页-banner.fc2eb858.jpg";